import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useAuth } from '../auth';
import { Loading } from '../lib/ui-loading-v2';

/**
 * RequireAuth – protect routes so only logged-in users see the page.
 * Redirects to login with returnUrl so after login the user is sent back (Task 0.6).
 */
export function RequireAuth({ component: Component, path, redirectTo = '/login', ...rest }) {
  const auth = useAuth();
  const location = useLocation();
  const pathArray = Array.isArray(path) ? path : [path];
  const isResolving = auth.isResolved === false && !auth.user;

  const requestedPath = location.pathname + (location.search || '');

  const loginUrlWithReturn = (pathToUse) => {
    if (!pathToUse || pathToUse === redirectTo) return redirectTo;
    const sep = redirectTo.indexOf('?') >= 0 ? '&' : '?';
    return `${redirectTo}${sep}returnUrl=${encodeURIComponent(pathToUse)}`;
  };

  const renderProtected = (props, pathToUse) => {
    if (isResolving) return <Loading />;
    if (!auth.user) return <Redirect to={loginUrlWithReturn(pathToUse)} />;
    return <Component {...props} />;
  };

  if (pathArray.length > 1) {
    return (
      <>
        {pathArray.map((singlePath, index) => (
          <Route
            key={`${singlePath}-${index}`}
            path={singlePath}
            {...rest}
            render={props => renderProtected(props, requestedPath)}
          />
        ))}
      </>
    );
  }

  return (
    <Route
      path={path}
      {...rest}
      render={props => renderProtected(props, requestedPath)}
    />
  );
}
